import React, { useState } from 'react'
import Header from '../header_'
import Footer from '../footer'
export default function Layout(props) {
    const [isGuest, setIsGuest] = useState(false)
    const lang = localStorage.getItem("lang")
    return (
        <React.Fragment>
            <Header isGuest={isGuest} />
            {props.children}
            <Footer />
        </React.Fragment>


    )
}
